import { useAuthStore } from '@stores/auth.store';
import { useMessage } from '@context/MessageProvider';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useLoginMutation = () => {
    const queryClient = useQueryClient();
    const login = useAuthStore((state) => state.login);
    const { showMessage } = useMessage();

    return useMutation({
        mutationFn: async ({ email, password }) => {
            return await login(email, password);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['auth'] });
            showMessage('success', 'Login successful');
        },
        onError: (error) => {
            showMessage('error', error.message || 'Login failed', 6);
        }
    });
};
